var styles = {"mgirl-notice-container":"main-module_mgirl-notice-container__MaR--","image":"main-module_image__UwlkD","opacity":"main-module_opacity__Tm3PJ","description":"main-module_description__R1y0C"};

export { styles as default };
